import { useEffect } from "react";

const DEFAULT_TITLE = "OKA VTC — Chauffeur privé VTC à Lyon | Transferts aéroport, mariage, affaires";
const DEFAULT_DESCRIPTION =
  "Chauffeur VTC privé à Lyon : transferts aéroport Lyon Saint-Exupéry, mise à disposition, véhicule de mariage et déplacements professionnels. Réservation en ligne, ponctualité garantie.";

/**
 * Met à jour le <title> et la meta description de la page.
 * Rétablit les valeurs par défaut (celles d'index.html) au démontage,
 * pour que la navigation entre pages garde des balises cohérentes.
 */
export default function useSEO({ title, description } = {}) {
  useEffect(() => {
    const previousTitle = document.title;
    const metaDescription = document.querySelector('meta[name="description"]');
    const previousDescription = metaDescription?.getAttribute("content");

    if (title) document.title = title;
    if (description && metaDescription) metaDescription.setAttribute("content", description);

    return () => {
      document.title = previousTitle ?? DEFAULT_TITLE;
      if (metaDescription) {
        metaDescription.setAttribute("content", previousDescription ?? DEFAULT_DESCRIPTION);
      }
    };
  }, [title, description]);
}
